export default class GrupoSeguranca {
  constructor(id = null, nome = null, roles = []) {
    this.id = id
    this.nome = nome
    this.roles = roles
  }
}
